//Start TokenService when app is Bootstrapped
angular.module('picmonicng').run([
  'TokenService',
  function (TokenService) {
    TokenService.init();
  },
]);

angular.module('picmonicng').factory('TokenService', [
  'Tokens',
  '$interval',
  '$rootScope',
  'UserService',
  function (Tokens, $interval, $rootScope, UserService) {
    var TokenService = {
      loading: false,
      values: {},
      timeLeft: 0,
      secondsLeft: 0,

      init: function () {
        if (UserService.user.user_id) {
          var self = this;
          $rootScope.$on('cardDataChanged', this.update.bind(this));
          $rootScope.$on('pathwaysDataChanged', this.update.bind(this));
          this.values = Tokens.get({ new_trial: 1 }, function (status) {
            var currentTime = new Date();
            self.values.timeToReset = currentTime.setSeconds(currentTime.getSeconds() + self.values.reset);
            self.loading = false;
            self.values.all_limits_reached = !status.tokens && !status.quiz_questions && !status.spacedrep_rounds;
            self.values.any_limits_reached = !status.tokens || !status.quiz_questions || !status.spacedrep_rounds;
          });
        }
      },

      redeem: function (card_id) {
        var self = this;
        var promise = Tokens.save({ card_id: card_id, new_trial: 1 });

        promise.$promise.then(function () {
          self.update();
        });

        return promise;
      },

      update: function () {
        var self = this;
        self.loading = true;
        self.values.$get({ new_trial: 1 }, function (status) {
          self.loading = false;
          var currentTime = new Date();
          self.values.timeToReset = currentTime.setSeconds(currentTime.getSeconds() + self.values.reset);
          self.values.all_limits_reached = !status.tokens && !status.quiz_questions && !status.spacedrep_rounds;
          self.values.any_limits_reached = !status.tokens || !status.quiz_questions || !status.spacedrep_rounds;
        });
      },

      //Start a countdown of time remaining for free access
      //if one is not already running
      startCountDown: function () {
        var self = this;
        if (angular.isDefined(self.interval)) return;
        self.interval = $interval(function () {
          self.decreamentCountdown();
        }, 1000);
      },

      //Stop a countdown if there is one running
      stopCountDown: function () {
        var self = this;
        if (angular.isDefined(self.interval)) {
          $interval.cancel(self.interval);
          self.interval = undefined;
        }
      },

      //Returns the time to reset free access in milliseconds
      //This is a diff of current time and time to reset access
      //Math.max a time of anything less that zero will to trigger update
      timeLeftToReset: function () {
        var currentTime = new Date();
        var timeToReset = new Date(this.values.timeToReset);
        var timeDifference = Math.max(0, timeToReset.getTime() - currentTime.getTime());
        return timeDifference;
      },

      //turns time remaining from milliseconds to nicely formatted 10h:53m:08s
      countdownFormat: function (timeLeft) {
        //Total time in ms converted to seconds
        var seconds = parseInt((timeLeft / 1000) % 60);
        var minutes = parseInt((timeLeft / (1000 * 60)) % 60);
        var hours = parseInt((timeLeft / (1000 * 60 * 60)) % 24);

        var result = hours < 10 ? '0' + hours : hours;
        result += 'h:' + (minutes < 10 ? '0' + minutes : minutes);
        result += 'm:' + (seconds < 10 ? '0' + seconds : seconds) + 's';
        return result;
      },

      //Will decreament time remaining by 1 seconds
      //Update countdown value with formatted return
      //Calls this.update for new values if timeleft is less than 1
      decreamentCountdown: function () {
        timeLeft = this.timeLeftToReset();
        this.countdown = this.countdownFormat(timeLeft);
        this.secondsLeft = parseInt(timeLeft / 1000);
        timeLeft -= 1000;
        if (timeLeft < 1) {
          this.update();
        }
      },
    };

    return TokenService;
  },
]);
